import { render } from "./AddContainersArea.vue?vue&type=template&id=5bc1c101&ts=true"
import script from "./AddContainersArea.vue?vue&type=script&lang=ts"
export * from "./AddContainersArea.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__